import logo from './logo.svg';
import React, {useState, useEffect} from 'react';
import './App.css';
import './qr.css';
import QRCode from 'qrcode.react';
import QRCodeScanner from 'qr.js';


const preventScreenshot = () => {
    const handleScreenshot = () => {
        alert('캡쳐 기능이 막혀있습니다');
        return false;
    };

    // 스크린샷 이벤트를 감지하여 처리
    window.addEventListener('screenshot', handleScreenshot);

    return () => {
        // 이벤트 리스너 제거
        window.removeEventListener('screenshot', handleScreenshot);
    };
};


function QRCodeGenerator() {
    const [token, setToken, secretKey] = useState('');
    const [qrCodeData, setQRCodeData] = useState('');
    const [countdown, setCountdown] = useState(60);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [QrCode_User_Info, setQrCode_User_Info] = useState('');
    const [QrCode_User_Info2, setQrCode_User_Info2] = useState([]);
    const secretKeys = localStorage.getItem('secretKey');
    const storedToken = localStorage.getItem('token');
    useEffect(() => {
        // 스크린샷 방지 함수 호출
        const unmountHandler = preventScreenshot();

        // 컴포넌트가 언마운트될 때 호출되는 함수
        return () => {
            unmountHandler();
        };
    }, []);
    // QR 코드 데이터 가져오기
    useEffect(() => {

        // 백엔드 API를 호출하여 QR 코드 데이터를 가져오는 로직을 추가해주세요.
        // 예시로 fetch()를 사용하여 호출하도록 설정했습니다.
        const url = `/backend/QrCode.php?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKeys)}`;

        fetch(url)
            .then(response => response.blob())
            .then(data => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    console.log(data);
                    setQRCodeData(reader.result);
                };
                reader.readAsDataURL(data);
            });
    }, []);

    useEffect(() => {
        const url2 = `/backend/QrCode_User_Info?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKeys)}`;
        fetch(url2)
            .then(response => response.json())
            .then(data2 => {
                // 서버로부터 받은 데이터 처리
                console.log(data2);
                setQrCode_User_Info(data2);
            });
    }, []);
    // 로그인 상태 확인
    useEffect(() => {
        // JWT 토큰을 확인하여 로그인 상태를 결정하는 로직을 추가해주세요.
        // 예시로 임시로 isLoggedIn 상태를 true로 설정하도록 설정했습니다.

        setIsLoggedIn(true);
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            // 카운트다운이 0이 되면 QR 코드 데이터 갱신하고 카운터를 다시 설정
            if (countdown === 0) {
                //refreshQRCode();  // 카운트 0되면 자동으로 큐알 리프레쉬
                //setCountdown(60); // 초기 카운트다운 값으로 설정
            } else {
                setCountdown(prevCountdown => prevCountdown - 1);
            }
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [countdown]);

    const refreshQRCode = () => {
        // 백엔드 API를 호출하여 새로운 QR 코드 데이터를 가져오는 로직을 추가해주세요.
        // 예시로 fetch()를 사용하여 호출하도록 설정했습니다.

        setCountdown(60); // 초기 카운트다운 값으로 설정

        const fetchQRCodeData = async () => {
            try {
                const response = await fetch(`/backend/QrCode.php?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKeys)}&t=${Date.now()}`);
                const data = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setQRCodeData(reader.result);
                };
                reader.readAsDataURL(data);

            } catch (error) {
                console.error("QR 코드 데이터 갱신 중 오류가 발생했습니다.", error);
            }
        };

        fetchQRCodeData();
    };

    return (
        <div className="App App-header gnb_b">
            <header>
                <div className="gnb_1">
                    <a className="gnb_logo" href="/"></a>
                    <div className="gnb_1_1">
                        {/*  <a className="gnb_qr" href="/"></a> */}
                        {/*  <a className="gnb_noti" href="/"></a> */}
                    </div>
                </div>
            </header>
            <div className="body">
                <div className="qrtext">
                    {isLoggedIn ? (
                        <div>


                            <p></p>
                            <div className="qrback-box">
                                <div className="code-box">
                                    {/* <QRCode value={qrCodeData} size={300} />*/}
                                    <img className="code-qr" src={qrCodeData}/>

                                    {/* 유효시간 마이너스 값으로 안넘어가도록, 유효시간 4분으로 글자 표시 0분 00초 표시 */}
                                </div>
                            </div>

                            {
                                QrCode_User_Info.KM_BM_GUBUNCD == '10' ? (
                                    <div className="under-box">
                                        <div className="text-box">
                                            <p>{QrCode_User_Info.KM_BM_NAME}</p>
                                            <p>{QrCode_User_Info.KM_BM_HAKGWAFNM}</p>
                                            <p>{QrCode_User_Info.KM_BM_ID}</p>
                                            <p>QR 유효시간: {countdown}초</p>
                                        </div>
                                        <div className="image-box">
                                            <img className="under-img" src={QrCode_User_Info.PHOTO_URL} alt="사용자 사진"/>
                                        </div>
                                    </div>
                                ) : (

                                    <div className="under-box">
                                        <div className="text-box">
                                            <p>{QrCode_User_Info.KM_BM_NAME}</p>
                                            <p>{QrCode_User_Info.KM_BM_HAKGWAFNM}</p>
                                            <p>{QrCode_User_Info.KM_BM_ID}</p>
                                            <p>QR 유효시간: {countdown}초</p>
                                        </div>
                                        <div className="image-box">
                                            <img className="under-img" src={`data:image/jpeg;base64,${QrCode_User_Info.PHOTO_URL}`} alt="사용자 사진"/>
                                        </div>
                                    </div>
                                )
                            }
                            <button className="refresh-b" onClick={refreshQRCode}>QR 새로고침</button>
                        </div>

                    ) : (
                        <div>
                            <p>로그인이 필요합니다.</p>
                            {/* 로그인 페이지로 이동하는 로직을 추가해주세요. */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default QRCodeGenerator;

